import { cmsPathList, oldCmsPathList } from "@/config";
import utils from "@/utils";
import Vue from "vue";
import VueRouter from "vue-router";
import HomePage from "../views/HomePage.vue";

Vue.use(VueRouter);

// const VueRouterPush = VueRouter.prototype.push;
// VueRouter.prototype.push = function push(to) {
//   return VueRouterPush.call(this, to).catch(err => err);
// };

const routes = [
  {
    path: "/",
    name: "Home",
    meta: {
      title: "Onitsuka Tiger 鬼塚虎中国官方网站",
      content: {
        keywords: "鬼冢虎,鬼塚虎,鬼塚虎官方,鬼塚虎中国",
        description:
          "日本时尚品牌 Onitsuka Tiger 鬼塚虎不懈呈献具有当代风格的系列单品，巧妙融合时尚触觉、运动风范、经典传承及创新锐意。1949 年，鬼塚喜八郎创立了 ASICS 的前身 Onitsuka Tiger 鬼塚虎，致力于促进青少年健康。自此，鬼塚虎的虎爪纹成为了世界知名运动品牌之一的代名词。 今天，日本传统工艺与现代时尚的融合继续书写着 Onitsuka Tiger 鬼塚虎的品牌传奇。从现代感的经典鞋款到全新的设计风格，品牌与志同道合的艺术家和文化大师们展开合作，将日本精神倾注于每一个 Onitsuka Tiger 鬼塚虎鞋履、服饰及配饰系列中。鬼冢虎中国官网倾心奉献。",
      },
    },
    component: HomePage,
  },
  {
    path: "/category/:id",
    name: "Category",
    meta: {
      title: "Onitsuka Tiger",
    },
    component: () => import("../views/List.vue"),
  },
  {
    path: "/detail/:id",
    name: "Detail",
    meta: {
      title: "商品详情 | Onitsuka Tiger",
    },
    component: () => import("../views/Detail.vue"),
  },
  {
    path: "/search",
    name: "Search",
    meta: {
      title: "搜索 | Onitsuka Tiger",
    },
    component: () => import("../views/Search.vue"),
  },
  {
    path: "/cart",
    name: "Cart",
    meta: {
      title: "购物车 | Onitsuka Tiger",
    },
    component: () => import("../views/Cart.vue"),
  },
  {
    path: "/checkout",
    name: "Checkout",
    meta: {
      title: "结算 | Onitsuka Tiger",
      requireAuth: true,
    },
    component: () => import("../views/Checkout.vue"),
  },
  {
    path: "/user",
    name: "User",
    redirect: "user/login",
    component: () => import("../views/Login.vue"),
    children: [
      {
        path: "login",
        name: "Login",
        meta: {
          title: "登录 | Onitsuka Tiger",
        },
        component: () => import("../views/user/login.vue"),
      },
      {
        path: "register",
        name: "Register",
        meta: {
          title: "注册 | Onitsuka Tiger",
        },
        component: () => import("../views/user/register.vue"),
      },
      {
        path: "setpassword",
        name: "Setpassword",
        meta: {
          title: "重置密码 | Onitsuka Tiger",
        },
        component: () => import("../views/user/setpassword.vue"),
      },
    ],
  },
  {
    path: "/size-guide",
    name: "Size-guide",
    meta: {
      title: "尺码对照表 | Onitsuka Tiger",
    },
    component: () => import("../views/footer/size-guide.vue"),
  },
  {
    path: "/store-finder",
    name: "Store-finder",
    meta: {
      title: "查找鬼塚虎店铺 | Onitsuka Tiger",
    },
    component: () => import("../views/footer/store-finder.vue"),
  },
  {
    path: "/about-order",
    name: "about-order",
    meta: {
      title: "关于订单 | Onitsuka Tiger",
    },
    component: () => import("../views/footer/about-order.vue"),
  },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    meta: {
      title: "隐私政策 | Onitsuka Tiger",
    },
    component: () => import("../views/footer/privacy-policy.vue"),
  },
  {
    path: "/account",
    name: "Account",
    meta: {
      title: "个人中心 | Onitsuka Tiger",
      requireAuth: true,
    },
    component: () => import("../views/Account.vue"),
  },
  {
    path: "/myaccount",
    meta: {
      title: "Onitsuka Tiger",
      requireAuth: true,
    },
    redirect: "myaccount/profile",
    component: () => import("@/views/myaccount/account.vue"),
    children: [
      {
        path: "profile",
        name: "Profile",
        meta: {
          title: "个人信息 | Onitsuka Tiger",
          requireAuth: true,
        },
        component: () => import("@/views/myaccount/profile.vue"),
      },
      {
        path: "memberBenefits",
        name: "MemberBenefits",
        meta: {
          title: "会员权益 | Onitsuka Tiger",
          requireAuth: true,
        },
        component: () => import("@/views/myaccount/member-benefits.vue"),
      },
      {
        path: "Coupons",
        name: "Coupons",
        meta: {
          title: "我的卡券 | Onitsuka Tiger",
          requireAuth: true,
        },
        component: () => import("@/views/myaccount/coupons.vue"),
      },
      {
        path: "orders",
        name: "Orders",
        meta: {
          title: "订单中心 | Onitsuka Tiger",
          requireAuth: true,
        },
        component: () => import("@/views/myaccount/orders.vue"),
      },
      {
        path: "addressbook",
        name: "Addressbook",
        meta: {
          title: "地址簿 | Onitsuka Tiger",
          requireAuth: true,
        },
        component: () => import("@/views/myaccount/addressbook.vue"),
      },
      {
        path: "orderdetail",
        name: "Orderdetail",
        meta: {
          title: "订单详情 | Onitsuka Tiger",
          requireAuth: true,
        },
        component: () => import("@/views/myaccount/order-detail.vue"),
      },
      {
        path: 'afterSaleDetail',
        name: 'afterSaleDetail',
        meta: {
          title: "售后详情 | Onitsuka Tiger",
          requireAuth: true,
        },
        component: () => import('@/views/myaccount/afterSaleDetail.vue')
      },
      {
        path: 'orderTrack',
        name: 'orderTrack',
        meta: {
          title: "物流详情 | Onitsuka Tiger",
          requireAuth: true,
        },
        component: () => import('@/views/myaccount/orderTrack.vue')
      }
    ],
  },
  {
    path: "/complete",
    name: "Complete",
    meta: {
      title: "绑定手机 | Onitsuka Tiger",
    },
    component: () => import("../views/user/complete.vue"),
  },
  {
    path: "/cms/:key*",
    name: "CMS",
    meta: {
      title: "Onitsuka Tiger",
    },
    component: () => import("@/views/CMS.vue"),
    // }, {
    //   path: '/location-selector',
    //   name: 'LocationSelector',
    //   meta: {
    //     title: '地区选项 | Onitsuka Tiger'
    //   },
    //   component: () => import('@/views/LocationSelector.vue')
  },
  {
    path: "/brand/:key*",
    name: "CMS",
    meta: {
      title: "Onitsuka Tiger",
    },
    component: () => import("@/views/CMS.vue"),
  },
  ...oldCmsPathList.map((path) => {
    return {
      path,
      name: "CMS",
      meta: {
        title: "Onitsuka Tiger",
        type: "path"
      },
      component: () => import("@/views/CMS.vue"),
    };
  }),
  ...cmsPathList.map((path) => {
    return {
      path,
      name: "webBQCms",
      meta: {
        title: "Onitsuka Tiger",
      },
      component: () => import("@/views/webBQCms.vue"),
    };
  }),
  {
    path: `/${process.env.VUE_APP_WEBBQCMS_URL}/:key*`,
    name: "webBQCms",
    meta: {
      title: "Onitsuka Tiger",
    },
    component: () => import("@/views/webBQCms.vue"),
  },
  {
    path: "/BQCms/:key*",
    name: "BQCms",
    meta: {
      title: "Onitsuka Tiger",
    },
    component: () => import("@/views/BQCms.vue"),
  },
  {
    path: "*",
    name: "NotFound",
    // component: () => import('../views/NotFound.vue'),
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_BASE_URL,
  // base: process.env.VUE_APP_PUBLIC_PATH,
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        selector: to.hash,
      };
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});

if (process.env.VUE_APP_ENV === "uat") {
  router.beforeEach((to, from, next) => {
    const localPassportLoginTime = localStorage.getItem(
      "localPassportLoginTime"
    );
    // 判断登录是否过期的函数
    function isLoginExpired(localPassportLoginTime) {
      return (
        Date.now() - parseInt(localPassportLoginTime) >= 1 * 24 * 60 * 60 * 1000
      );
    }

    // 本地校验用户名和密码的函数，这里假设用户名为"user"，密码为"password"
    function verifyCredentials(password) {
      // 简单校验 先不加密
      return btoa(password) === "YzhmMDhkYWY3Yzk0ZmUxM2I=";
    }
    // uat环境判断登录时间是否存在或是否已过期
    if (!localPassportLoginTime || isLoginExpired(localPassportLoginTime)) {
      // 如果登录时间不存在或已过期，则弹出浏览器原生的输入框
      const password = prompt("请输入访问密码");

      // 进行本地校验用户名和密码
      if (password && verifyCredentials(password)) {
        // 如果用户名和密码校验通过，则更新登录时间并允许继续访问
        localStorage.setItem("localPassportLoginTime", Date.now());
        next();
      } else {
        alert("访问密码错误");
        //需要手动移除#app 否则cms仍然会插入#app中nuxt渲染
        let app = document.querySelector("#app");
        if (app && app.parentNode) {
          app.parentNode.removeChild(app);
        }
        // 如果用户名或密码为空，或校验不通过，则阻止继续访问
        next(false);
      }
    } else {
      // 如果登录未过期，则允许继续访问
      next();
    }
  });
}

router.beforeEach((to, from, next) => {
  if (to.name === "Home") {
    // 首页拦截到CMS首页
    let search = to.fullPath.includes("?")
      ? `?${to.fullPath.split("?")[1]}`
      : "";
    //本地就不做特殊处理了
    let baseUrl =
      process.env.VUE_APP_BASE_URL === "/" ? "" : process.env.VUE_APP_BASE_URL;
    if (utils.isMobile()) {
      location.href = `${location.origin}${baseUrl}/${process.env.VUE_APP_WEBBQCMS_URL}/home-mb${search}`;
    } else {
      location.href = `${location.origin}${baseUrl}/${process.env.VUE_APP_WEBBQCMS_URL}/home${search}`;
    }
  } else {
    // 继续路由导航
    next();
  }
});

router.afterEach((to, from) => {
  if (to.name === "webBQCms" && from.name) {
    //如果是vuerouter跳转进来需要reload 否则不会请求nuxt加载
    //然后让其重新加载 from变空从上面走
    location.reload();
  }
});

//fix:NavigationDuplicated
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
export default router;
